<template>
  <div
      class="container-fluid menu p-3"
      :class="{'menu-highlighted': shouldHighlight}"
  >
    <div class="d-flex justify-content-between">
      <a v-smooth-scroll href="#app" class="logo d-flex align-items-center">
        <img
            src="../assets/img/logo-sf-solo.svg"
            alt="SimpleFinance logo"
        />

        <div class="d-none d-sm-block menu-title m-3">
          SimpleFinance
        </div>
      </a>
      <div class="d-flex justify-content-end align-items-center">
        <a class="d-none d-md-flex m-3 menu-item" v-smooth-scroll href="#features">Overzicht</a>
        <a class="d-none d-md-flex m-3 menu-item" v-smooth-scroll href="#pricing">Kosten</a>
        <a class="m-3 menu-item" target="_blank" href="https://app.simplefinance.nl/">
          Login
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    scrollPos: {
      type: Number,
    },
  },
  computed: {
    shouldHighlight() {
      return this.scrollPos > 200;
    },
  },
};
</script>

<style scoped>
div.menu {
  z-index: 1000;
  position: fixed;
  transition-duration: 500ms;
  transition-timing-function: ease-in-out;
}

div.menu-title {
  transition-duration: 500ms;
  transition-timing-function: ease-in-out;
  opacity: 0;
  font-weight: lighter;
  font-size: 25px;
}

a.logo {
  text-decoration: none;
  color: black;
}

.menu-item {
  color: white;
  text-decoration: none;
  font-weight: lighter;
  transition-duration: 250ms;
  transition-timing-function: ease-in-out;
}


div.menu-highlighted {
  background: white;
}

div.menu-highlighted a.menu-item {
  color: black;
}

.menu-item:hover,
div.menu-highlighted a.menu-item:hover,
a.logo:hover,
div.menu-highlighted a.logo:hover {
  color: #B24592;
}

div.menu-highlighted div.menu-title {
  opacity: 1;
}

</style>
